import { ServiceMaker, methods, services } from "@/services";
import Api from "@/services/service-v2";

export const portfolioByNumber = (data) =>
    ServiceMaker("/users/customer/customer-list", methods.POST, services.nipige, data);
export const portfolioDetails = (data) =>
    ServiceMaker(`/order/api/v1/get/listbycustomer/${data}?limit=20&type=PRODUCT&isMaster=true&status=Delivered`, methods.GET, services.master);
export const fetchSubCategories = (payload) =>
    ServiceMaker(`/catalog/api/catalog/read/catalog?parent=${payload.catalogId}`, methods.GET, services.master);
export const fetchAssetType = (payload) =>
    ServiceMaker(`/catalog/api/catalog/read/catalog/item/by?page=1&limit=count`, methods.POST, services.master, payload);
export const addAssset = (payload) =>
    ServiceMaker(`/order/api/v2/sales-order/create`, methods.POST, services.master, payload);
export const deleteAsset = (payload) =>
    ServiceMaker(`/order/api/v1/order/updateOrderStatus/${payload.id}`, methods.POST, services.master, payload.status);